export const capCase = (str) =>  str.replace(/\b\w/g, (l) => l.toUpperCase());

export const notNull = (value) => value !== null && value !== undefined;

export const notEmpty = (value) => value !== null && value !== undefined && value !== '';

export const  arraySubtractAll = (arr1, arr2) => {
  let result = [...arr1];
  for (let item of arr2) {
      let index;
      while ((index = result.indexOf(item)) !== -1) {
          result.splice(index, 1);
      }
  }
  return result;
}

export const toTitleCase = (str) => {
    return str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

export const getEnvironment = () => {
    if (window.location.origin === 'http://localhost') {
        return 'development';
    } else if (window.location.origin === 'https://oregontopshelf.posabittest.com' ||
               window.location.origin === 'https://wpqa.posabittest.com') {
        return 'qa';
    } else if (window.location.origin === 'https://wpstaging.posabittest.com') {
        return 'staging';
    } else if (window.location.origin === 'https://wpdemo.posabittest.com') { // todo setup later when needed
        return 'demo';
    } else {
        return 'production';
    }
}

export const getCdnUrl = () => {
    const environment = getEnvironment();
    if (environment === 'development') {
        return 'https://d1fm4joq9v95a0.cloudfront.net/ecomm/'; // Dev
    } else if (environment === 'qa') {
        return 'https://d1gaaui79z0boh.cloudfront.net/ecomm/'; // QA
    } else if (environment === 'staging') {
        return 'https://d2zcnqu0uuqlur.cloudfront.net/ecomm/'; // Staging
    } else if (environment === 'demo') {
        return 'https://d3sqi60mef0gcq.cloudfront.net/ecomm/'; // Demo
    } else {
        return 'https://dmazpby8qypw2.cloudfront.net/ecomm/'; // Production
    }
}
